import { useState } from "react";
import { ChevronDown, Phone, Mail } from "lucide-react";

// Fixed bottom-right attribution badge.
// Kept below dialogs/sheets so it never blocks cart actions.
export default function TrademarkBadge() {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="fixed bottom-3 right-3 z-[5] select-none"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={() => setOpen((v) => !v)}
        className={`bg-white/80 backdrop-blur border border-[#E6E0D4] rounded-xl shadow-[0_4px_16px_-6px_rgba(11,31,58,0.18)] transition-all duration-200 ${open ? "px-3 py-2" : "px-2.5 py-1.5 cursor-pointer hover:bg-white"}`}
      >
        <div className="flex items-center gap-1.5 text-[10.5px] text-[#0B1F3A]/75">
          <span className="text-[9px] uppercase tracking-[0.12em] text-[#0B1F3A]/50">by</span>
          <img src="/jgi-solutions-logo.svg" alt="JGI Solutions" className="h-3.5 w-auto opacity-75" />
          <ChevronDown size={11} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </div>
        {open && (
          <div className="mt-1.5 pt-1.5 border-t border-[#EEE8DC] text-[11px] text-[#0B1F3A]/75 space-y-1 min-w-[200px]">
            <div className="flex items-center gap-1.5">
              <Phone size={11} className="text-[#0B1F3A]/45" />
              <a href="tel:+17252842122" className="hover:text-[#0B1F3A]">725.284.2122</a>
            </div>
            <div className="flex items-center gap-1.5">
              <Mail size={11} className="text-[#0B1F3A]/45" />
              <a href="mailto:jagilv498@gmail.com" className="hover:text-[#0B1F3A] truncate">jagilv498@gmail.com</a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
